'use client';

import { PREMIUM_GRADIENT_BACKGROUND } from '@/components/paid-access/premium-crown-icon';
import type { CSSProperties } from 'react';
import styles from './cms-nav-link-badge.module.css';

export function getCmsNavLinkBadgeDiscountPercent(label: string) {
  const match = /^(\d{1,3})% off$/i.exec(label.trim());
  const percentOff = Number(match?.[1]);
  return percentOff >= 1 && percentOff <= 100 ? percentOff : null;
}

function resolveBadgeAppearance(label: string): {
  className: string;
  style?: CSSProperties;
} {
  const normalized = label.trim().toLowerCase();

  if (normalized === 'hot') {
    return { className: styles.badgeHot };
  }

  if (normalized === 'new') {
    return { className: styles.badgeNew };
  }

  if (getCmsNavLinkBadgeDiscountPercent(normalized) !== null) {
    return {
      className: styles.badgeDiscount,
      style: { backgroundImage: PREMIUM_GRADIENT_BACKGROUND },
    };
  }

  return { className: styles.badgeDefault };
}

export function CmsNavLinkBadge({
  className,
  label,
}: {
  className?: string;
  label: string;
}) {
  const normalizedLabel = label.trim();

  if (!normalizedLabel) {
    return null;
  }
  const appearance = resolveBadgeAppearance(normalizedLabel);

  return (
    <span
      className={`${styles.badge} ${appearance.className}${
        className ? ` ${className}` : ''
      }`}
      style={appearance.style}
    >
      {normalizedLabel.toUpperCase()}
    </span>
  );
}
